import { create } from 'zustand'
import type { CallSession } from '@/modules/calls/services/call.service'

interface DesktopCall {
  call: CallSession
  number: string
  leadName: string
}

interface CallUiState {
  /** Call whose result form is open. */
  outcomeCallId: string | null
  /** Desktop "call from your phone" panel. */
  desktopCall: DesktopCall | null
  /** A tel: link was opened — open the result form when the app is visible again. */
  awaitingReturnCallId: string | null
  openOutcome: (callId: string) => void
  closeOutcome: () => void
  openDesktop: (call: DesktopCall) => void
  closeDesktop: () => void
  awaitReturn: (callId: string | null) => void
}

export const useCallStore = create<CallUiState>((set) => ({
  outcomeCallId: null,
  desktopCall: null,
  awaitingReturnCallId: null,
  openOutcome: (callId) =>
    set({
      outcomeCallId: callId,
      desktopCall: null,
      awaitingReturnCallId: null,
    }),
  closeOutcome: () => set({ outcomeCallId: null }),
  openDesktop: (desktopCall) => set({ desktopCall }),
  closeDesktop: () => set({ desktopCall: null }),
  awaitReturn: (callId) => set({ awaitingReturnCallId: callId }),
}))
